import script from "./AddEntitySubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEntitySubscription.vue?vue&type=script&setup=true&lang=js"

import "./AddEntitySubscription.vue?vue&type=style&index=0&id=90011474&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90011474"]])

export default __exports__